import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { type Currency, currencies } from '../utils/currencies'

const LOCAL_STORAGE_KEY = 'selectedCurrency'

export const useCurrencySelector = (initialValue: string = 'BRL') => {
  const { t } = useTranslation('countryCurrency')
  const initialCurrency =
    localStorage.getItem(LOCAL_STORAGE_KEY) || initialValue
  const [tempCurrency, setTempCurrency] = useState<string>(initialCurrency)

  const handleTempChange = (value: string) => {
    setTempCurrency(value)
  }

  const saveCurrency = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, tempCurrency)
  }

  const formattedCurrencies: { label: string; value: string }[] = useMemo(
    () =>
      currencies.map(currency => ({
        label: `${t(currency.name as any)}`,
        value: currency.code,
      })),
    [currencies, t],
  )

  const currentCurrency: Currency | undefined = useMemo(
    () => currencies.find(c => c.code === tempCurrency),
    [tempCurrency, currencies],
  )

  return {
    selectedCurrency: initialCurrency,
    tempCurrency,
    currentCurrency,
    formattedCurrencies,
    handleTempChange,
    saveCurrency,
  }
}
